import { Link } from 'react-router-dom';
import { LegalPage } from './LegalPage';
import { LEGAL_CONTACT, LEGAL_VERSIONS } from '@makhe/shared';

export default function TermsPage() {
  return (
    <LegalPage title="Terms of Service" lastUpdated={LEGAL_VERSIONS.terms}>
      <p>
        These Terms of Service (&quot;Terms&quot;) govern your access to and use of the Makhe
        platform operated by {LEGAL_CONTACT.companyName} (&quot;Makhe&quot;, &quot;we&quot;,
        &quot;us&quot;). By creating an account you agree to these Terms, our{' '}
        <Link to="/legal/privacy">Privacy Policy</Link>, and our{' '}
        <Link to="/legal/refunds">Refund &amp; Cancellation Policy</Link>.
      </p>

      <h2>1. Who may use Makhe</h2>
      <p>
        Makhe is a student-only beauty marketplace. You must be at least 18 years old (or the age
        of majority in South Africa) and a currently enrolled student at a recognised South
        African university, TVET, or college. You must complete student verification before
        booking or selling services.
      </p>

      <h2>2. Marketplace role</h2>
      <p>
        Makhe connects verified student buyers with verified student sellers (creators). Makhe is
        <strong> not</strong> a party to the service contract between buyer and seller. Creators
        are independent contractors, not employees or agents of Makhe. Makhe does not perform
        beauty services and is not responsible for the quality, safety, or legality of services
        performed in person.
      </p>

      <h2>3. Accounts</h2>
      <p>
        You are responsible for your account credentials and all activity under your account. You
        must provide accurate information. We may suspend or terminate accounts that breach these
        Terms, our <Link to="/legal/community-guidelines">Community Guidelines</Link>, or applicable
        law.
      </p>

      <h2>4. Bookings &amp; payments</h2>
      <p>
        Bookings are made through the in-app flow. Prices include a disclosed platform commission
        (currently 10%). Payments are processed by Paystack. <strong>Makhe does not hold your
        funds.</strong> When you book, Paystack places a pre-authorization hold on your card; the
        amount is only captured once the service is confirmed complete or the auto-confirmation
        period elapses, at which point the creator is paid directly into their own bank account and
        Makhe receives only its commission. Cancellations before capture release the hold. See our{' '}
        <Link to="/legal/refunds">Refund Policy</Link> for full detail.
      </p>

      <h2>5. Safety</h2>
      <p>
        In-person services carry inherent risks. Sellers may set safety preferences (e.g. client
        type, location rules). Users should meet in public campus areas when possible, keep
        others informed of their plans, and use emergency contacts shown in active bookings.
        Makhe does not guarantee campus security response for off-campus locations.
      </p>

      <h2>6. Prohibited conduct</h2>
      <p>
        You may not harass others, circumvent payments, post fraudulent listings, impersonate
        another student, or use Makhe for unlawful purposes. See our Community Guidelines for
        detail.
      </p>

      <h2>7. Content</h2>
      <p>
        You retain ownership of content you upload but grant Makhe a licence to display, store,
        and promote it on the platform. We may remove content that violates these Terms.
      </p>

      <h2>8. Disputes between users</h2>
      <p>
        Disputes should be raised in-app within 48 hours of the scheduled service end. Makhe may
        review disputes and adjust payment outcomes at its discretion. Our decision on payment
        disputes is final for platform purposes but does not limit your legal rights.
      </p>

      <h2>9. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by South African law, Makhe is not liable for indirect,
        incidental, or consequential damages arising from use of the platform or in-person
        services arranged through it. Our aggregate liability is limited to the fees Makhe earned
        from your account in the 12 months preceding the claim.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These Terms are governed by the laws of the Republic of South Africa. Disputes with Makhe
        are subject to the jurisdiction of South African courts.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions: <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>
      </p>
    </LegalPage>
  );
}
